import { pageLanguage } from "../util/common";

function updateQueryStringParameter(uri, key, value) {
	var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
	var separator = uri.indexOf('?') !== -1 ? "&" : "?";
	if (uri.match(re)) {
		return uri.replace(re, '$1' + key + "=" + value + '$2');
	} else {
		return uri + separator + key + "=" + value;
	}
}

var getBrowserWidth = function(){
    if(window.innerWidth < 768){
        // Extra Small Device
        return "xs";
    } else if(window.innerWidth < 991){
        // Small Device
        return "sm"
    } else if(window.innerWidth < 1199){
        // Medium Device
        return "md"
    } else {
        // Large Device
        return "lg"
    }
};

$.fn.changeVal = function (v) {
    return this.val(v).trigger("change");
}

$(document).ready(function() {

	$('.filter #contract_rent').click(() => {
		$(".period_of_permanence").css("display","block");		
		$("#price_min").prop("disabled", true).hide().next(".select2-container").hide();
		$("#price_max").prop("disabled", true).hide().next(".select2-container").hide();
		$("#rent_price_min").prop("disabled", false).show().next(".select2-container").show();
		$("#rent_price_max").prop("disabled", false).show().next(".select2-container").show();
		$(".surface_settings").css("display","none");
	});

	$('.filter #contract_sale').click(() => {
		$(".period_of_permanence").css("display","none");
		$("#price_min").prop("disabled", false).show().next(".select2-container").show();
		$("#price_max").prop("disabled", false).show().next(".select2-container").show();
		$("#rent_price_min").prop("disabled", true).hide().next(".select2-container").hide();
		$("#rent_price_max").prop("disabled", true).hide().next(".select2-container").hide();
		$(".surface_settings").css("display","block");
	});

	$('[name="home_type"]').change((e) => {
		$('#city').changeVal('');

		if (e.originalEvent !== undefined)	{
			$('.loader').css('display', 'flex');
		}

		$.ajax({
			dataType: 'html',
			url: '/get-zones',
			type: 'POST',
			data: {
			  home_type: $('[name="home_type"]:checked').val(),
			  lang: pageLanguage()
			},
			async: true,
			beforeSend: function() {
				$('#city').html('');
				$('#city').prop('disabled', true);
				$('.field-label', $('#city').parents('.form-field')).addClass('disabled');
			},
			success: function (result) {
				$('#city').append(result);
				$('#city').prop('disabled', false);
				$('.field-label', $('#city').parents('.form-field')).removeClass('disabled');
  
				$('.loader').css('display','none');
			},
			error: function(xhr, status, error) {
				//  console.log(error);
				$('#city').prop('disabled', false);
				$('.field-label', $('#city').parents('.form-field')).removeClass('disabled');
			} 
		});
	});

	$('#city').change((e) => {
		if(!$("#city").val()) {
			$("#zones").html('');
			$('#zones').prop('disabled', true);
			$('.field-label', $('#zones').parents('.form-field')).addClass('disabled');
			return;
		}

		if (e.originalEvent !== undefined)	{
			$('.loader').css('display', 'flex');
		}

		$.ajax({
			dataType: 'html',
			url: '/get-zones',
			type: 'POST',
			data: {
				city: $('#city').val(),
				home_type: $('[name="home_type"]:checked').val(),
				lang: pageLanguage()
			},
			async: true,
			beforeSend: function() {
				$('#zones').html('');
				$('#zones').prop('disabled', true);
				$('.field-label', $('#zones').parents('.form-field')).addClass('disabled');
			},
			success: function (result) {
				if(!!result) {
					$('#zones').append(result);
					$('#zones').prop('disabled', false);
					$('.field-label', $('#zones').parents('.form-field')).removeClass('disabled');
				}

				$('.loader').css('display','none');
			},
			error: function(xhr, status, error) {
				//  console.log(error);
				// $('#zones').prop('disabled', false);
			}
	    });
	});

	$('select#order_by').change(function() {
		$('select#order_by').val($(this).val()); // fix order_by (desktop/mobile with same id)
		window.location.href = updateQueryStringParameter(window.location.href, "orderby", $(this).val() );
	});

	// $('#myTab li:first-child a').tab('show')
	$('#myTab li:first-child a').click(function() {
		$('.order label').show();
		$('.order #order_by').show();
	});

	$('#myTab li:last-child a').click(function() {
		$('.order label').hide();
		$('.order #order_by').hide();
	});

	$(document).on('click touchstart', '.filter-mobile', function() {
		$(".search-container .filter").show("slide", { direction: "down" }, 300);
		$("body").addClass("noscroll");
	});

	$(document).on('click touchstart', '.closeMobile', function() {
		$(".search-container .filter").hide("slide", { direction: "down" }, 300);
		$("body").removeClass("noscroll");
	});

	$(window).resize(function() {
		$("body").removeClass("noscroll");
		if($( window ).width() > 992) {
			$(".search-container .filter").show();
		} else {
			$(".search-container .filter").hide();
		}
	});

	var device = getBrowserWidth();
	if(device!="sm" && device!="xs") {
		$('.search-page select[data-select]').select2({
			width: '100%',
		});
	}

	$('.search-page select[data-select]:hidden').next(".select2-container").hide();

	$('.filter_current_by_type label').click(function(){

		$(this).siblings('[type="radio"]').prop('checked', true);

		window.location.href = updateQueryStringParameter(window.location.href, 'home_type', $(this).siblings('[type="radio"]').val() );

	})

});


// WEBPACK FOOTER //
// ./scripts/components/search.js